"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MasonryGridItem = exports.MasonryGrid = void 0;
var vue_1 = require("vue");
var imagesloaded_1 = __importDefault(require("imagesloaded"));
var lodash_1 = require("lodash");
var resizeGridItem = function (item) {
    var grid = item;
    while (grid !== null && typeof grid.classList !== 'undefined' && !grid.classList.contains('masonry-grid')) {
        grid = grid.parentElement;
    }
    if (!grid || grid === window.document.documentElement) {
        // masonry-grid root element not yet inserted
        return;
    }
    var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    if (item instanceof HTMLElement) {
        item.style.gridRowEnd = "span 1"; // reset
    }
    var rowSpan = Math.ceil((item.scrollHeight
        + parseFloat(window.getComputedStyle(item).getPropertyValue('margin-bottom'))
        + parseFloat(window.getComputedStyle(item).getPropertyValue('padding-bottom'))
        + rowGap)
        /
            (rowHeight + rowGap));
    if (item instanceof HTMLElement) {
        item.style.gridRowEnd = "span " + rowSpan;
    }
};
var resizeAllGridItems = function (rootelement) {
    if (rootelement === void 0) { rootelement = null; }
    var allItems;
    if (rootelement === null) {
        allItems = window.document.querySelectorAll('.masonry-grid .masonry-grid-item');
    }
    else {
        allItems = rootelement.querySelectorAll('.masonry-grid-item');
    }
    for (var x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
};
exports.MasonryGrid = vue_1.defineComponent({
    name: 'MasonryGrid',
    props: {
        minMax: {
            type: String,
            "default": '34rem'
        }
    },
    setup: function (props) {
        var grid = vue_1.ref(null);
        var minMax = function () {
            var _a, _b;
            if (grid.value) {
                var gridWidth = grid.value.getBoundingClientRect().width;
                var firstItemWidth = (_b = (_a = grid.value.querySelector('.masonry-grid-item')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
                if (gridWidth < firstItemWidth) {
                    return "10rem";
                }
            }
            return props.minMax;
        };
        window.addEventListener('DOMContentLoaded', lodash_1.debounce(function () { return resizeAllGridItems(grid.value); }, 150));
        window.addEventListener('resize', lodash_1.debounce(function () {
            if (grid.value) {
                grid.value.style.gridTemplateColumns = "repeat(auto-fill, minmax(" + minMax() + ", 1fr))";
            }
            resizeAllGridItems(grid.value);
        }, 150));
        vue_1.onMounted(function () {
            vue_1.nextTick(function () {
                if (grid.value) {
                    grid.value.style.gridTemplateColumns = "repeat(auto-fill, minmax(" + minMax() + ", 1fr))";
                }
            });
        });
        vue_1.onUpdated(function () {
            vue_1.nextTick(function () {
                resizeAllGridItems(grid.value);
            });
        });
        return {
            grid: grid,
        };
    },
    template: /* html */ "\n        <div\n            class=\"masonry-grid grid grid-flow-row gap-x-12 gap-y-px\"\n            style=\"grid-auto-rows: 10px;\"\n            ref=\"grid\">\n            <slot></slot>\n        </div>\n    ",
});
exports.MasonryGridItem = vue_1.defineComponent({
    name: 'MasonryGridItem',
    props: {
        bottomGap: {
            type: Number,
            "default": 12
        }
    },
    setup: function (props) {
        var gridItem = vue_1.ref(null);
        vue_1.onMounted(function () {
            if (gridItem.value === null) {
                return;
            }
            gridItem.value.classList.add("mb-" + props.bottomGap);
            if (gridItem.value.querySelector('img') !== null) {
                imagesloaded_1["default"](gridItem.value, function () {
                    if (gridItem.value) {
                        resizeGridItem(gridItem.value);
                    }
                });
            }
        });
        vue_1.onUpdated(function () {
            if (gridItem.value) {
                resizeGridItem(gridItem.value);
            }
        });
        return {
            gridItem: gridItem,
        };
    },
    template: /* html */ "\n        <div class=\"masonry-grid-item\" ref=\"gridItem\"><slot></slot></div>\n    ",
});
// const createMasonryGridApp = () => {
//     return createApp({
//         name: 'Masonry',
//         components: { MasonryGrid, MasonryGridItem },
//     });
// };
// document.querySelectorAll('.masonry').forEach(el => {
//     createMasonryGridApp().mount(el);
// });
